import React from 'react';
import { Text } from '@fiverr-private/typography';
import { Box, theme } from '@fiverr-private/theme';
import { BUYABLE_TYPE, useGrossPriceCalculator } from '@fiverr-private/price_upfront_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { DiscountTooltip } from './DiscountTooltip';

interface CrossedPriceProps {
  fontSize: keyof typeof theme.bodySizes;
  discountPercentage: number;
  priceInUsd: number;
}

export const CrossedPrice: React.FC<CrossedPriceProps> = ({
  fontSize = theme.bodySizes.b_md,
  discountPercentage,
  priceInUsd,
}) => {
  const { currencyConverter } = useGigPageContext();
  const grossPriceCalculator = useGrossPriceCalculator(BUYABLE_TYPE.GIG);
  const grossPrice = currencyConverter.convert(grossPriceCalculator(priceInUsd) * 100);

  return (
    <Text fontWeight="normal" decoration="lineThrough" size={fontSize}>
      {grossPrice}
      <Box as="span" marginLeft="2">
        <DiscountTooltip discountPercentage={discountPercentage} />
      </Box>
    </Text>
  );
};
